exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.shadow[data-v-1d0f0627] {\n    background: transparent;\n}\n}\n", ""]);

